import React from 'react';
import clsx from 'clsx';

import scss from './BurgerIcon.module.scss';

function BurgerIcon({ onChange, isOpen, 'aria-label': ariaLabel }) {
  const toggleBurgerMenu = () => {
    if (onChange) {
      onChange(!isOpen);
    }
  };

  return (
    <button
      type='button'
      className={clsx(scss.burgerIcon, isOpen && scss.open)}
      onClick={toggleBurgerMenu}
      aria-label={ariaLabel}
      aria-expanded={isOpen}>
      <span />
      <span />
      <span />
      <span />
    </button>
  );
}

export default BurgerIcon;
